<template>
    <div>
        <v-toolbar dense color="primary" app :clipped-left="true" dark tabs>

            <v-btn icon @click="goBack()">
                <v-icon>arrow_back</v-icon>
            </v-btn>

            <v-toolbar-title>Lat & Long</v-toolbar-title>

            <v-spacer></v-spacer>
            <v-btn icon @click.stop="done()" :disabled="accuracy > limit || center.lat >= 0">
                <v-icon>done_all</v-icon>
            </v-btn>

        </v-toolbar>
        <main>
        <v-container fluid>

            <v-alert outline color="error" icon="warning" :value="error">
                {{error}}
            </v-alert>

            <gmap-map
                :center="center"
                :zoom="16"
                style="height: calc(70vh)">
                <gmap-marker
                    :position="center"
                    :clickable="false"
                    :draggable="true"/>

                <gmap-marker
                    :position="center"
                    :clickable="false"
                    :draggable="true"/>
            </gmap-map>

            <v-alert outline color="error" icon="error" :value="accuracy > limit" >
                Proximidade: {{accuracy}}m <br/> lat & lng {{out}}
            </v-alert>

            <v-alert outline color="success" icon="check_circle" :value="accuracy <= limit && center.lat < -0">
                Já pode salvar!<br/>
                Clique no ícone: <v-icon>done_all</v-icon> acima.
            </v-alert>

        </v-container>

        </main>

    </div>
</template>

<script>
    /* eslint-disable indent */

    import { Sync } from "../class/sync";
    import { Ordens } from "../class/ordens";

    export default {
        name: "buscar-lat-long",
        data () {
            return {
                limit: 2200,
                out: null,
                error: null,
                accuracy: null,
                center: { lat: 0.0, lng: 0.0 },
                watchID: null
            };
        },

        beforeMount () {
            if (!this.$route.params.id || !parseInt(this.$route.params.id)) {
                return this.goBack();
            }
            if (!navigator.geolocation) {
                alert("Geolocation not is supported!");
            } else {
                this.openLatLong();
            }
        },
        beforeDestroy () {
            if (this.watchID) {
                navigator.geolocation.clearWatch(this.watchID);
            }
        },
        methods: {
            goBack: function () {
                this.$router.push("/ver-ordem/" + this.$route.params.id);
            },
            done: async function () {
                let ordem = await Ordens.get(parseInt(this.$route.params.id));
                if (ordem) {
                    let param = {
                        latitude: this.center.lat,
                        longitude: this.center.lng,
                        id_contratos_servicos: ordem.id_contratos_servicos,
                        id_ordem_servico: ordem.id_ordem_servico,
                        action: "SYNC_LATLNG"
                    };
                    let key = await Sync.add(param);
                    await Sync.syncOne(key, this.$socket);
                    this.goBack();
                }
            },
            openLatLong: function () {
                this.dialog = false;
                this.watchID = navigator
                    .geolocation
                    .watchPosition(
                        this.processGeolocation,
                        this.geolocationError,
                        {
                            enableHighAccuracy: true,
                            timeout: 3000,
                            maximumAge: 0
                        }
                    );
            },
            processGeolocation: function (position) {
                console.log(position);
                this.out = position.coords.latitude + "," + position.coords.longitude;
                this.center = {
                    lat: position.coords.latitude,
                    lng: position.coords.longitude
                };
                this.accuracy = position.coords.accuracy;
            },
            geolocationError: function (error) {
                switch (error.code) {
                    case error.PERMISSION_DENIED:
                        this.error = "User denied the request for Geolocation.";
                        break;
                    case error.POSITION_UNAVAILABLE:
                        this.error = "Location information is unavailable.";
                        break;
                    case error.TIMEOUT:
                        this.error = "The request to get user location timed out.";
                        break;
                    case error.UNKNOWN_ERROR:
                        this.error = "An unknown error occurred.";
                        break;
                }
            }
        }
    };
</script>

<style scoped>

</style>
